import React from 'react';
import { Button } from 'tea-component';
import { useIntl, getLocale } from 'umi';
import CloumsCenter from '@/pages/intelligence/components/TableComponents/components/CloumsCenter';
import { AnyObjectSchema } from 'yup';

const getLocaleGenreName = (genreData: any, name: string, locale: string) => {
  if (locale === 'zh-CN') {
    return genreData?.genre_cn || name;
  }

  return genreData?.genre_en || name;
};

const getSubGenreName = (context: any, name: string, locale: string, dealMap: any) => {
  if (!name || typeof name !== 'string' || !(dealMap?.fn instanceof Function)) {
    return name;
  }

  return name
    .split(/(\|)/)
    .map((subGenreName) => {
      const targetName = subGenreName.trim();

      if (!targetName) {
        return subGenreName;
      }

      let genreData = dealMap.fn(dealMap.data, dealMap.type, context.genre, targetName);

      if (!genreData?.genre_cn && !genreData?.genre_en && context.genre !== '') {
        genreData = dealMap.fn(dealMap.data, dealMap.type, '', targetName);
      }

      const prefix = subGenreName.match(/^\s*/)?.[0] || '';
      const suffix = subGenreName.match(/\s*$/)?.[0] || '';

      return `${prefix}${getLocaleGenreName(genreData, targetName, locale)}${suffix}`;
    })
    .join('');
};

export default function SpecialColContent(props: AnyObjectSchema) {
  const { context, config, hideCond, getIsHideCol, onGameItemClick, isLabelHide, dealMap } = props;

  const { type, key, clickKey, align = 'right', childWidth, childAlign } = config || {};

  const { formatMessage } = useIntl();
  const locale = getLocale();
  const isHide =
    hideCond &&
    getIsHideCol instanceof Function &&
    getIsHideCol(hideCond, context, 'specicalContent');

  const getElContent = (_type: string) => {
    if (!!isHide) return null;
    switch (_type) {
      // 文本来源于接口，所以中英翻译要借助字段转换
      case 'text':
        const name = context[key];
        let text = name;
        if (key === 'sub_genre') {
          text = getSubGenreName(context, name, locale, dealMap);
        }
        if (key === 'genre') {
          text = getLocaleGenreName(
            dealMap.fn(dealMap.data, dealMap.type, name),
            name,
            locale,
          );
        }
        return (
          <span
            style={{
              display: isLabelHide ? 'none' : '',
            }}
          >
            {text}
            {/* {locale === 'zh-CN'
              ? ()?.genre_cn || name
              : (key === 'sub_genre' && dealMap.fn(dealMap.data, dealMap.type, context.genre, name))
                  ?.genre_cn || name} */}
          </span>
        );
      case 'action':
        return (
          <Button
            className="table-link"
            style={{
              display: isLabelHide ? 'none' : '',
            }}
            onClick={() => {
              if (onGameItemClick instanceof Function) {
                onGameItemClick(clickKey, context);
              }
            }}
            type="link"
          >
            {formatMessage({ id: key })}
          </Button>
        );
      default:
        return null;
    }
  };
  return (
    <>
      {align === 'center' ? (
        <CloumsCenter width={childWidth} align={childAlign}>
          {getElContent(type)}
        </CloumsCenter>
      ) : (
        getElContent(type)
      )}
    </>
  );
}
